import { Button } from "@/components/ui/button";
import { useState } from "react";
import DesktopGuard from "@/components/auth/desktop/DesktopGuard";
import useERC20Balance from "@/hooks/portfolio/useERC20Balance";
import { useSession } from "@/contexts/LitSessionProvider";
import { CashItem } from "./CashItem";
import { toSpecialFixed } from "@/lib/misc/utils";
import CustomDialog from "@/components/ui/customDialog";
import DesktopDeposit from "@/components/auth/desktop/DesktopDeposit";
export default function UserCash() {
  const [showCashModal, setShowCashModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  function toggleModal() {
    setIsOpen(!isOpen);
  }
  const {
    PKP
  } = useSession();
  const {
    data: assetData,
    isLoading: isLoadingAssetData
  } = useERC20Balance({
    evmAddresses: [PKP?.additionalEthAddress],
    solanaAddresses: [PKP?.solanaAddress],
    useGeniusAPI: true
  });
  const totalCash = () => {
    let totalUsd = 0;
    if (assetData && assetData?.balances.length) {
      assetData.balances.map(token => {
        if (token.contract_ticker_symbol === "USDC" || token.contract_ticker_symbol === "USDT") {
          totalUsd += token.usd_value;
        }
      });
    }
    return totalUsd;
  };
  return <div className="genius-shadow my-4 items-center bg-genius-indigo rounded-[20px] border-genius-blue border-[1px] overflow-hidden" data-sentry-component="UserCash" data-sentry-source-file="UserCash.tsx">
            <div className="p-3 pb-0 flex items-center justify-between">
                <p className="text-[20px]">Cash</p>
                <div className="flex items-center justify-center">
                    <div>
                    </div>
                </div>
                <Button onClick={() => setShowCashModal(!showCashModal)} variant="ghost" className="px-0 w-[83px] h-[32px] ta-c justify-center rounded-full bg-genius-blue hover:bg-genius-blue text-[14px]" data-sentry-element="Button" data-sentry-source-file="UserCash.tsx">
                    {!showCashModal ? 'Expand' : 'Collapse'}
                </Button>
            </div>
            <div className="mt-2 pb-2">
                <>
                    <div className="px-3 flex items-center justify-between">
                        <p className="text-[32px]">{toSpecialFixed(totalCash(), 2).value}<span className="text-genius-cream/50">USD</span></p>
                    </div>
                    {isLoadingAssetData && <h1 className="p-4 text-[16px] ta-c font-normal">Loading assets..</h1>}
                    {showCashModal && assetData && assetData?.balances.length && assetData.balances.map(token => {
          if (token.contract_ticker_symbol === "USDC" || token.contract_ticker_symbol === "USDT") return <CashItem assetItem={token} toggleModal={toggleModal} />;
        })}
                </>
            </div>
            <CustomDialog isOpen={isOpen} toggleModal={toggleModal} className={"h-fit w-[572px]"} data-sentry-element="CustomDialog" data-sentry-source-file="UserCash.tsx">
                <DesktopDeposit data-sentry-element="DesktopDeposit" data-sentry-source-file="UserCash.tsx" />
            </CustomDialog>
        </div>;
}